module.exports = __webpack_public_path__ + "img/img-badge-005-off@3x.ad680872.png";